import { useLayoutEffect } from 'react';
import classNames from 'classnames';
import { DOMUtils } from '@deephaven/utils';
import "./LoadingSpinner.css";
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingSpinner(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    dataTestId = _ref['data-testid'];
  useLayoutEffect(() => {
    // Ensure all of our loading spinner animations are synchronized based
    // on same start time.
    DOMUtils.syncAnimationStartTime('loading-spinner-rotate', 0);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: classNames('loading-spinner', className),
    "aria-label": "Loading...",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "data-testid": dataTestId,
    role: "progressbar"
  });
}
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map